const axios = require('axios');
import apiUrl from '../../api.config';

const PATIENT_CATEGORY_API_URL = `${apiUrl}patientCategory`;

const PatientCategoryService = {
    getBySchool() {
        return axios.get(PATIENT_CATEGORY_API_URL + '/getBySchool', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    add(patientCategoryData) {
        return axios.post(PATIENT_CATEGORY_API_URL + '/add', patientCategoryData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    update(patientCategoryData) {
        return axios.post(PATIENT_CATEGORY_API_URL + '/update', patientCategoryData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    delete(patientCategoryIds) {
        return axios.post(PATIENT_CATEGORY_API_URL + '/delete', patientCategoryIds, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
}

export default PatientCategoryService;